import { withPageBaseDomain } from '@rg/shared-ng';

/** The base domains one build is served under (migration decision D29). */
export const BASE_DOMAINS: readonly string[] = ['realguest.it', 'realguest.io'];

/**
 * Environment keys that are never moved to the page's base domain. Empty: every
 * URL here is one of our service hosts. clientUrl is only read by the native
 * deep-link host guard (deep-link.ts), where the page host is Capacitor's
 * `localhost`, so it stays the build's value there without a keep entry.
 */
export const KEEP: readonly string[] = [];

/**
 * The environment with every URL on one of BASE_DOMAINS moved onto the page's own
 * base domain (except KEEP), so the web app on checkin-staging.realguest.io calls
 * api-staging.realguest.io / appsync-staging.realguest.io, while the same build on
 * checkin.realguest.it keeps calling the .it hosts. A no-op on localhost — which
 * includes the native iOS/Android apps (Capacitor serves them from `localhost`) —
 * and on any other host. Applied inside each environment file, so every consumer
 * (including module-level captures) sees the derived values.
 */
export function onPageDomain<T>(
  env: T,
  pageHost: string | null | undefined = globalThis.location?.hostname
): T {
  return withPageBaseDomain(env, pageHost, {
    baseDomains: BASE_DOMAINS,
    keep: KEEP,
  });
}
